var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectmanagement2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1979.26 1368.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{opacity:0.5;fill:url(#linear-gradient-3);}.cls-5{opacity:0.68;}.cls-12,.cls-6{fill:#fff;}.cls-6{mix-blend-mode:soft-light;}.cls-7{fill:#bdd0fb;}.cls-8{fill:#91b3fa;}.cls-9{fill:#7d97f4;}.cls-10{fill:#18174a;}.cls-11{fill:#2b69b3;}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:url(#linear-gradient-27);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 662.09,
    x2: 1979.26,
    y2: 662.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 153.84,
    y1: 644.67,
    x2: 1545.1,
    y2: 644.67,
    gradientTransform: "translate(1456.27 -232.25) rotate(87.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 265.89,
    y1: 598.17,
    x2: 1357.74,
    y2: 598.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1572.67,
    y1: 1002.48,
    x2: 1515.63,
    y2: 1002.48,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -949.19,
    y1: 1294.15,
    x2: -934,
    y2: 1294.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 641.65, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1003.94,
    y1: 1293.37,
    x2: -990.82,
    y2: 1293.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 641.65, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1622.28,
    y1: 958.13,
    x2: 1568.61,
    y2: 1098.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1667.03,
    y1: 975.21,
    x2: 1613.37,
    y2: 1115.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1620.7,
    y1: 1019.54,
    x2: 1703.87,
    y2: 997.71,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -891.5,
    y1: 902.47,
    x2: -903,
    y2: 952.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 641.65, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1587.26,
    y1: 955.26,
    x2: 1587.93,
    y2: 972.76,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1516.22,
    y1: 910.46,
    x2: 1516.89,
    y2: 936.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1592.69,
    y1: 868.68,
    x2: 1601.35,
    y2: 925.01,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -6722.88,
    y1: -2383.88,
    x2: -6704.88,
    y2: -2421.21,
    gradientTransform: "matrix(-0.75, -0.67, -0.67, 0.75, -5056.49, -1683.63)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -6736.58,
    y1: -2390.48,
    x2: -6718.58,
    y2: -2427.81,
    gradientTransform: "matrix(-0.75, -0.67, -0.67, 0.75, -5056.49, -1683.63)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3797.15,
    y1: 610.1,
    x2: -3757.65,
    y2: 530.6,
    gradientTransform: "matrix(-0.98, -0.21, -0.21, 0.98, -2882.8, -323.05)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3427.07,
    y1: 1358,
    x2: -3403.72,
    y2: 1358,
    gradientTransform: "matrix(-1, 0, 0, 1, -2902.08, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -3525.75,
    y1: 1450.09,
    x2: -3492.14,
    y2: 1057.31,
    gradientTransform: "matrix(-1, 0, 0, 1, -2902.08, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3535.57,
    y1: 1353.74,
    x2: -3497.78,
    y2: 1353.74,
    gradientTransform: "matrix(-1, 0, 0, 1, -2902.08, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 509.48,
    y1: 1217.38,
    x2: 563.98,
    y2: 1344.38,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 650.73,
    y1: 1020.64,
    x2: 569.75,
    y2: 1135.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 671.25,
    y1: 1064.49,
    x2: 574.55,
    y2: 1226.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 624.39,
    y1: 969.71,
    x2: 615.89,
    y2: 1034.71,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 617.76,
    y1: 924.77,
    x2: 629.76,
    y2: 984.77,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -3853.98,
    y1: 581.86,
    x2: -3814.48,
    y2: 502.36,
    gradientTransform: "matrix(-0.98, -0.21, -0.21, 0.98, -2882.8, -323.05)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 722.55,
    y1: 901.66,
    x2: 732.55,
    y2: 982.16,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 494.9,
    y1: 1098.61,
    x2: 607.02,
    y2: 1098.61,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1916.69,528.56q-3.27-3.48-6.7-6.8c-14.68-14.33-30.9-27.17-42.79-44-28.18-39.83-27-93.83-19.92-142.59s18.61-98.78,7.15-146.64-46.27-88.46-89.34-110.19-93.55-25.54-140.41-15.08c-47.11,10.51-90.29,34.56-136.37,49.14s-99.44,18.47-139.57-9c-20.24-13.89-35.74-34.89-57.67-45.71-27.83-13.72-60.93-8.54-90.24,1.36-38.89,13.14-74.89,33.87-110.6,54.47-61.26,35.34-122,79-189.46,99.79C834.2,233.81,766,243.73,697.55,255.11,600.22,271.28,492.23,229.8,398,208.55c-65.2-14.71-132.64-25.31-199.49-18.81-28.64,2.78-69.55,6.54-94.17,23.38C83.75,227.23,64.07,255,51.77,276.8,7.38,355.53,16.35,439.54,48.53,520.39c26.36,66.23,60.83,131.93,62,203.51.57,33.86-3.47,73-10,106.08-6.93,35-33.78,71.94-49.8,103.66C39.49,955.94,28.2,978.32,20.08,1002c-26,75.87-41.54,203.85,49.67,239.57,42,16.44,78.07,6,119.76.34,95.56-13.06,181.92,19.5,275.48,28.73,129.65,12.79,262.1-3.69,384.68-49.24,45.88-17.05,94-35.11,137.66-57.56,38.19-19.65,83-16.87,125.41-13.84,99.27,7.08,195.16,37.21,291.38,61.25a2389.19,2389.19,0,0,0,358.55,61c25.69,2.38,52.24,4.25,76.7-4.18,35-12.08,60.89-44.09,75.15-79.23,24.63-60.72,30.08-123.09,32-187.4,2.07-71.08,19.48-140.55,28.2-210.85C1986.1,698.63,1979.4,595.11,1916.69,528.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 849.47,
    cy: 644.67,
    rx: 644.54,
    ry: 695.72,
    transform: "translate(168.16 1465.05) rotate(-87.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 811.81,
    cy: 598.17,
    rx: 545.92,
    ry: 515.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1027.2,647.79c-.17,113.68-8,227.59-28,339.66-5.07,28-11,55.85-18,83.45a803,803,0,0,1-25.08,81.66c-10,26.67-21.64,53-37.4,77-7.95,11.92-17,23.35-28.08,32.75a80.26,80.26,0,0,1-18.37,11.84,55.09,55.09,0,0,1-21.46,5.05,54.14,54.14,0,0,1-21.69-4,75.11,75.11,0,0,1-18.8-11.2c-11.39-9.1-20.6-20.4-28.68-32.23-16.05-23.85-27.83-50.08-38-76.7a786.09,786.09,0,0,1-25.34-81.59c-7.08-27.57-13-55.42-18.13-83.41-10.2-56-17.16-112.5-21.86-169.17s-7-113.56-7.29-170.43c-.14-28.44.64-56.86,1.65-85.28s2.63-56.8,4.72-85.15c4.2-56.71,10.49-113.28,19.82-169.39,4.69-28.05,10.15-56,16.72-83.66a803.94,803.94,0,0,1,23.75-82c4.77-13.42,10-26.69,15.94-39.65a288.45,288.45,0,0,1,20.41-37.62C782,55.79,791,44.4,802.19,35.28a71.35,71.35,0,0,1,18.55-11.11,52.22,52.22,0,0,1,21.33-3.79,56.5,56.5,0,0,1,21.07,4.94,82.18,82.18,0,0,1,18.32,11.43C892.65,45.84,901.9,57,910.12,68.63c16.33,23.5,28.64,49.43,39.3,75.8a778.06,778.06,0,0,1,27,81c7.58,27.43,14,55.16,19.57,83.05C1017.94,420.16,1026.87,534.09,1027.2,647.79Zm-8.41,0c.1-56.65-2-113.3-6.76-169.75s-11.67-112.73-22.15-168.39c-5.23-27.82-11.32-55.49-18.57-82.85A772.41,772.41,0,0,0,945.42,146c-10.29-26.29-22.23-52.12-38.08-75.46C899.38,59,890.4,48,879.62,39a79.62,79.62,0,0,0-17.57-11.24A52.63,52.63,0,0,0,842,22.87a49.19,49.19,0,0,0-20.24,3.81,68.73,68.73,0,0,0-17.7,10.88c-10.76,8.94-19.48,20.18-27.06,32a285.74,285.74,0,0,0-19.74,37.36c-5.76,12.9-10.79,26.12-15.38,39.49a799.78,799.78,0,0,0-22.71,81.75c-6.23,27.61-11.37,55.47-15.73,83.46-8.69,56-14.33,112.41-17.9,169s-4.86,113.22-4.76,169.87q-.22,85,6,169.78C691,876.71,697.47,933,707.2,988.83c4.87,27.88,10.56,55.62,17.38,83.08a780.71,780.71,0,0,0,24.52,81.14c9.81,26.44,21.29,52.45,36.79,75.88,7.8,11.61,16.68,22.63,27.44,31.36a70.16,70.16,0,0,0,17.56,10.65,48.29,48.29,0,0,0,19.85,3.78,50.68,50.68,0,0,0,19.66-4.81,75.41,75.41,0,0,0,17.19-11.29c10.53-9,19.22-20.19,26.88-31.91,15.24-23.61,26.54-49.68,36.25-76.16a798.68,798.68,0,0,0,24.22-81.23c6.75-27.47,12.37-55.23,17.2-83.12,9.66-55.8,16.08-112.14,20.35-168.62S1018.81,704.44,1018.79,647.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1314,647.79c-.4,73.2-9.81,146.44-29.4,217-19.94,70.43-50,138.19-90.81,199a572.74,572.74,0,0,1-69.35,84.94,486.54,486.54,0,0,1-85.38,68.73,411.36,411.36,0,0,1-99.61,45.54,372.56,372.56,0,0,1-216.61.1,412.21,412.21,0,0,1-99.69-45.47A486.93,486.93,0,0,1,537.64,1149a573.62,573.62,0,0,1-69.49-84.92c-40.89-60.84-71-128.63-91-199.1a787.59,787.59,0,0,1-22-107.61,861.88,861.88,0,0,1-7.43-109.59,861.82,861.82,0,0,1,7.49-109.59,788.91,788.91,0,0,1,22.12-107.58c20.08-70.44,50.25-138.18,91.17-199a572.36,572.36,0,0,1,69.5-84.82,485.51,485.51,0,0,1,85.46-68.56A413.53,413.53,0,0,1,723,33a370,370,0,0,1,216.27.09,413,413,0,0,1,99.54,45.38,485.05,485.05,0,0,1,85.34,68.61,572.81,572.81,0,0,1,69.37,84.84c40.83,60.77,70.94,128.48,90.92,198.89C1304.08,501.36,1313.53,574.58,1314,647.79Zm-9.65,0c-.11-72.38-9.12-144.83-28.22-214.7S1228,296,1188.19,235.43a567.23,567.23,0,0,0-67.78-84.68c-25.32-25.88-53.28-49.29-83.86-68.75a404.77,404.77,0,0,0-98.34-45.46,360.76,360.76,0,0,0-214.11.08,405.3,405.3,0,0,0-98.27,45.54c-30.54,19.49-58.46,42.92-83.73,68.81a567.12,567.12,0,0,0-67.66,84.7c-39.72,60.55-68.57,127.87-87.68,197.59A795.18,795.18,0,0,0,365.68,539.6,827.12,827.12,0,0,0,365.75,756a791.21,791.21,0,0,0,21.16,106.31c19.15,69.7,48,137,87.8,197.46a565.8,565.8,0,0,0,67.66,84.6c25.27,25.85,53.17,49.27,83.71,68.69a406.61,406.61,0,0,0,98.19,45.37,358.28,358.28,0,0,0,213.77.09,406.35,406.35,0,0,0,98.27-45.3c30.57-19.4,58.51-42.79,83.82-68.63a566.68,566.68,0,0,0,67.8-84.58c39.83-60.5,68.79-127.8,88-197.53S1304.18,720.16,1304.33,647.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.71,397.94l145-1.18,145-.66,290-.54,290,.59,145,.73,145,1.26a.43.43,0,0,1,0,.86l-145,1.26-145,.72-290,.59-290-.53-145-.66-145-1.18a.64.64,0,0,1-.63-.64A.63.63,0,0,1,267.71,397.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M435.93,155.07c34.31-.54,68.63-.78,103-1.17l102.94-.67c34.32-.28,68.63-.25,102.95-.33l103-.2,205.89.59,103,.72c34.31.43,68.63.69,102.94,1.27a.42.42,0,0,1,.42.43.42.42,0,0,1-.42.42c-34.31.58-68.63.83-102.94,1.26l-103,.73-205.89.59-103-.2c-34.32-.08-68.63,0-102.95-.34l-102.94-.66c-34.32-.39-68.64-.63-102.95-1.17a.64.64,0,0,1,0-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.32,640.8l157.6-1.17,157.6-.66,315.2-.54,315.19.59,157.6.73,157.6,1.26a.43.43,0,0,1,.43.43.43.43,0,0,1-.43.42l-157.6,1.26-157.6.73-315.19.59-315.2-.54-157.6-.66-157.6-1.17a.64.64,0,0,1-.63-.64A.63.63,0,0,1,217.32,640.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.71,883.67l145-1.18,145-.66,290-.53,290,.59,145,.72,145,1.26a.43.43,0,0,1,0,.86l-145,1.26-145,.73-290,.59-290-.54-145-.66-145-1.18a.63.63,0,0,1,0-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1280.25,1129.39H456.68a2.23,2.23,0,0,1,0-4.45h823.57a2.23,2.23,0,1,1,0,4.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1843.54,937.52c8.66-78-23.1-166-40.46-247.44-9.18-43.07-14.35-86-9.13-130,5.18-43.72,23.71-91.53,3.16-134.06-41.42-85.68-130-42.38-179,25.34-56.87,78.58-68.26,203.72-87.18,300.49-11.41,58.33-29.71,118.43-34.58,177.61-8.08,98,16.69,164.87,65.19,208.74A141.32,141.32,0,0,0,1730.1,1154C1778.46,1124.47,1829.56,1063.42,1843.54,937.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1650.7,1304.7a2.15,2.15,0,0,1-1.22-1.52c-8.48-40.37-26-151.21-31.63-281.77-4.15-95.83-1.61-188.47,7.53-275.34,11.44-108.64,33.3-208.52,65-296.87a2.17,2.17,0,1,1,4.08,1.46c-31.56,88-53.34,187.54-64.74,295.81-9.12,86.65-11.65,179.06-7.52,274.67,5.63,130.29,23.09,240.87,31.54,281.15a2.16,2.16,0,0,1-1.67,2.56A2.1,2.1,0,0,1,1650.7,1304.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1961.86,1058.81c5.79-52.15-15.43-110.92-27-165.36-6.13-28.79-9.58-57.46-6.1-86.85,3.47-29.23,15.85-61.17,2.11-89.6-27.68-57.26-86.87-28.32-119.63,16.93-38,52.52-45.62,136.16-58.27,200.83-7.62,39-19.85,79.15-23.11,118.7-5.4,65.52,11.16,110.19,43.57,139.5a94.44,94.44,0,0,0,112.66,10.53C1918.37,1183.76,1952.52,1143,1961.86,1058.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1833,1304.21a1.45,1.45,0,0,1-.81-1c-5.67-27-17.37-101.06-21.14-188.31-2.77-64.05-1.08-126,5-184,7.65-72.6,22.25-139.35,43.43-198.4a1.44,1.44,0,1,1,2.72,1c-21.09,58.83-35.65,125.34-43.26,197.7-6.1,57.91-7.79,119.67-5,183.57,3.76,87.07,15.43,161,21.08,187.89a1.46,1.46,0,0,1-1.12,1.72A1.53,1.53,0,0,1,1833,1304.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.9,1309.78C145.79,1195.2,646.51,1178.47,863,1316c10.1,6.41,2.46,16.92-12.27,16.88L30,1330.52C12.16,1330.47,1.72,1318.5,11.9,1309.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1001.22 1022.91 974.24 1264.85 1287.22 1264.85 1246.45 1022.91 1001.22 1022.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1354.63,1314.35H896.57c-12.44,0-21.79-8.86-19.38-18.37l5.88-23.25c1.76-7,9.45-12.12,18.59-12.41l441.59-13.78c9.54-.29,18,4.77,20.07,12l10.6,37C1376.67,1305.22,1367.28,1314.35,1354.63,1314.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M608.59,501v554.1a84.06,84.06,0,0,0,81.89,84c202.39,5.22,723.66,17.88,916.32,15a61.86,61.86,0,0,0,60.89-60.09c3.71-128.73,9.75-438.27-12.58-582a63.65,63.65,0,0,0-60.86-53.87c-169.57-5.43-733.36-22.65-925.93-18.33A61.11,61.11,0,0,0,608.59,501Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M643.36,498.31v526.44a48.7,48.7,0,0,0,48,48.69l887.74,13.28a47.4,47.4,0,0,0,48.1-47.22l1.8-521.73A34.67,34.67,0,0,0,1595.16,483L681.83,460.76A37.56,37.56,0,0,0,643.36,498.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1635.27,1108.17h0l-991.91-20.08a1.37,1.37,0,1,1,.06-2.74l991.91,20.08a1.37,1.37,0,0,1,0,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1143.15,1266.5a1.37,1.37,0,0,1-1.37-1.35,1.39,1.39,0,0,1,1.36-1.4l18.92-.27h0a1.38,1.38,0,0,1,0,2.75l-18.92.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M894.15,1301.42l-.22,0a1.37,1.37,0,0,1-1.14-1.57l2.7-16.91a18.73,18.73,0,0,1,18.26-15.81l200.71-2.94a1.44,1.44,0,0,1,1.39,1.36,1.38,1.38,0,0,1-1.35,1.39l-200.71,2.94a16,16,0,0,0-15.59,13.49l-2.7,16.91A1.37,1.37,0,0,1,894.15,1301.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M814.89,740.63H694.43c-16.46,0-29.57,11.61-28.77,25.47l13.71,236.12c.75,12.94,13.41,23.1,28.77,23.1H814.89c15.9,0,28.8-10.87,28.8-24.29V764.91C843.69,751.5,830.79,740.63,814.89,740.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1071,740.63H892.34c-14.43,0-26.13,10.87-26.13,24.28V1001c0,13.42,11.7,24.29,26.13,24.29H1071c14.43,0,26.13-10.87,26.13-24.29V764.91C1097.1,751.5,1085.4,740.63,1071,740.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M789.24,501.31V615.75l-117,4.09a109.37,109.37,0,1,0,117-118.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1088.5,580.67H924.32a8.92,8.92,0,0,1-8.89-8.89h0a8.92,8.92,0,0,1,8.89-8.89H1088.5a8.92,8.92,0,0,1,8.89,8.89h0A8.92,8.92,0,0,1,1088.5,580.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1088.5,539.72H924.32a8.92,8.92,0,0,1-8.89-8.89h0a8.92,8.92,0,0,1,8.89-8.89H1088.5a8.92,8.92,0,0,1,8.89,8.89h0A8.92,8.92,0,0,1,1088.5,539.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 915.43,
    y: 602.11,
    width: 181.97,
    height: 17.78,
    rx: 8.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1088.5,663.77H924.32a8.92,8.92,0,0,1-8.89-8.89h0a8.92,8.92,0,0,1,8.89-8.89H1088.5a8.92,8.92,0,0,1,8.89,8.89h0A8.92,8.92,0,0,1,1088.5,663.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1088.5,703.94H924.32a8.92,8.92,0,0,1-8.89-8.89h0a8.92,8.92,0,0,1,8.89-8.9H1088.5a8.92,8.92,0,0,1,8.89,8.9h0A8.92,8.92,0,0,1,1088.5,703.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1226.54,
    cy: 592.53,
    rx: 65.62,
    ry: 60.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1389.61,
    cy: 592.53,
    rx: 65.62,
    ry: 60.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1552.69,
    cy: 594.52,
    rx: 65.62,
    ry: 60.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1265.53,579.64a36.65,36.65,0,0,1,3.15,14.88c0,21.64-18.87,39.18-42.14,39.18s-42.15-17.54-42.15-39.18,18.87-39.17,42.15-39.17c.71,0,1.42,0,2.12,0v-9.93c-.7,0-1.41-.05-2.12-.05-29.18,0-52.83,22-52.83,49.1s23.65,49.11,52.83,49.11,52.82-22,52.82-49.11a46.08,46.08,0,0,0-4-18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1411.36,627.67a44.27,44.27,0,0,1-22.46,6c-23.28,0-42.15-17.54-42.15-39.18s18.87-39.17,42.15-39.17c.71,0,1.42,0,2.12,0v-9.93c-.7,0-1.41-.05-2.12-.05-29.18,0-52.83,22-52.83,49.1s23.65,49.11,52.83,49.11a55.53,55.53,0,0,0,27.75-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1587.86,616.55A43,43,0,0,1,1553,633.7c-23.28,0-42.15-17.54-42.15-39.18s18.87-39.17,42.15-39.17c.71,0,1.42,0,2.12,0v-9.93c-.7,0-1.41-.05-2.12-.05-29.18,0-52.83,22-52.83,49.1s23.65,49.11,52.83,49.11c18,0,34-8.42,43.5-21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1280,679.36H1173.07c-6.71,0-12.15,5-12.15,11.29s5.44,11.3,12.15,11.3H1280c6.71,0,12.15-5.06,12.15-11.3S1286.71,679.36,1280,679.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1443.08,679.36H1336.15c-6.71,0-12.15,5-12.15,11.29s5.44,11.3,12.15,11.3h106.93c6.71,0,12.15-5.06,12.15-11.3S1449.79,679.36,1443.08,679.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1499.23,702h106.92c6.72,0,12.16-5.06,12.16-11.3s-5.44-11.29-12.16-11.29H1499.23c-6.72,0-12.16,5-12.16,11.29S1492.51,702,1499.23,702Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1280,714.5H1173.07c-6.71,0-12.15,5.06-12.15,11.3v66.52c0,6.24,5.44,11.29,12.15,11.29H1280c6.71,0,12.15-5.05,12.15-11.29V725.8C1292.15,719.56,1286.71,714.5,1280,714.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1443.08,714.5H1336.15c-6.71,0-12.15,5.06-12.15,11.3v66.52c0,6.24,5.44,11.29,12.15,11.29h106.93c6.71,0,12.15-5.05,12.15-11.29V725.8C1455.23,719.56,1449.79,714.5,1443.08,714.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1606.15,714.5H1499.23c-6.72,0-12.16,5.06-12.16,11.3v66.52c0,6.24,5.44,11.29,12.16,11.29h106.92c6.72,0,12.16-5.05,12.16-11.29V725.8C1618.31,719.56,1612.87,714.5,1606.15,714.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M887,892.62v89.64c0,14,12.22,25.38,27.3,25.38H1046.4c15.49,0,28-11.67,28-26.06v-135c0-11.36-15.08-16.72-23.23-8.25l-25.53,26.51c-9.82,10.21-26.45,11.65-38.13,3.3l-2.44-1.75a25.51,25.51,0,0,0-30.29.69l-14,11a39.15,39.15,0,0,1-38.74,5.3h0C895,880.56,887,885.41,887,892.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1167.41,
    y: 932.19,
    width: 22.14,
    height: 93.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1204.4,
    y: 964.2,
    width: 22.14,
    height: 61.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1241.39,
    y: 885.1,
    width: 22.14,
    height: 140.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1278.38,
    y: 991.64,
    width: 22.14,
    height: 33.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1315.36,
    y: 903.84,
    width: 22.14,
    height: 121.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1352.35,
    y: 924.88,
    width: 22.14,
    height: 100.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1389.34,
    y: 947.74,
    width: 22.14,
    height: 77.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1426.33,
    y: 856.75,
    width: 22.14,
    height: 168.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1463.31,
    y: 874.58,
    width: 22.14,
    height: 150.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1500.3,
    y: 901.56,
    width: 22.14,
    height: 123.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1537.29,
    y: 994.76,
    width: 22.14,
    height: 30.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1574.28,
    y: 935.39,
    width: 22.14,
    height: 89.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1225.34,856.75h-97.4a7.22,7.22,0,1,0,0,14.4h97.4a7.22,7.22,0,1,0,0-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1225.34,834.21h-97.4a7.22,7.22,0,1,0,0,14.4h97.4a7.22,7.22,0,1,0,0-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1401.05,856.75h-97.4a7.22,7.22,0,1,0,0,14.4h97.4a7.22,7.22,0,1,0,0-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1401.05,834.21h-97.4a7.22,7.22,0,1,0,0,14.4h97.4a7.22,7.22,0,1,0,0-14.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1167.41,
    y: 958.97,
    width: 22.14,
    height: 66.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1204.4,
    y: 981.78,
    width: 22.14,
    height: 43.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1241.39,
    y: 925.42,
    width: 22.14,
    height: 99.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1278.38,
    y: 1001.32,
    width: 22.14,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1315.36,
    y: 920.92,
    width: 22.14,
    height: 104.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1352.35,
    y: 953.76,
    width: 22.14,
    height: 71.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1389.34,
    y: 970.05,
    width: 22.14,
    height: 55.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1426.33,
    y: 905.22,
    width: 22.14,
    height: 120.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1463.31,
    y: 892.92,
    width: 22.14,
    height: 132.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1500.3,
    y: 937.14,
    width: 22.14,
    height: 88.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1537.29,
    y: 1003.55,
    width: 22.14,
    height: 21.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1574.28,
    y: 961.25,
    width: 22.14,
    height: 64.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781,608.75V502.31a109.87,109.87,0,0,0-107.6,108.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 662.11,
    y: 868.15,
    width: 8.81,
    height: 140.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 676.83,
    y: 916.46,
    width: 8.81,
    height: 92.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 691.55,
    y: 797.08,
    width: 8.81,
    height: 211.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 706.28,
    y: 957.86,
    width: 8.81,
    height: 50.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 721,
    y: 825.37,
    width: 8.81,
    height: 183.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 735.72,
    y: 857.11,
    width: 8.81,
    height: 151.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 750.45,
    y: 891.62,
    width: 8.81,
    height: 117.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 765.17,
    y: 754.3,
    width: 8.81,
    height: 254.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 779.89,
    y: 781.21,
    width: 8.81,
    height: 227.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 794.62,
    y: 821.92,
    width: 8.81,
    height: 186.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 809.34,
    y: 962.58,
    width: 8.81,
    height: 46.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 824.06,
    y: 872.98,
    width: 8.81,
    height: 135.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1515.63,990.79s21.18,48.89,34.22,42.37,22.82-60.29,22.82-60.29S1531.92,963.09,1515.63,990.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1589.39,1294.19s1.77,10,2.64,20a6.84,6.84,0,0,1-6.54,7.41c-13.22.55-41.49,1.62-51.64,1.17a2.23,2.23,0,0,1-2-3h0a5,5,0,0,1,2.55-2.68l46.7-21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1590.84,1288.3l-1.42,12s-8.18,3.81-13.77-.48l3.39-13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1589.77,1062.82c.62,3.13,3.3,156.29-13.07,224.93a2.33,2.33,0,0,0,1.37,2.71,40.47,40.47,0,0,0,13.33,2.71,4,4,0,0,0,4-2.88c4.68-15.92,27.1-95.71,30-171.93,3.27-85.17,0-2.9,0-2.9l-1.92-52.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1643.11,1299.42s2.82,5.06,5.55,18.51a4.17,4.17,0,0,1-3.67,5c-4.36.43-11.08,1-16.46.94a4.15,4.15,0,0,1-4.12-4.64c.59-4.91,2.45-13,8.19-19.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1645.59,1284l-3.32,18.14s-3.29,2.45-9.8.67l1.59-19.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1654.57,1067.52c13.39,80.81-2.9,199.73-8.4,223a3.61,3.61,0,0,1-2.93,2.76,24.41,24.41,0,0,1-10.47-.42,3.33,3.33,0,0,1-2.39-3.06c-.74-18.82.59-134.34-11.89-180a10.31,10.31,0,0,0-4-5.72l-24.22-17.22-1.85-27.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1567.78,917.46c48.89-4.89,85.87,7.48,85.87,7.48,12,69.79,2.1,150.29,2.1,150.29-31.07,8.15-66.11-5-66.11-5-5.17-29.17-29.26-111.27-29.26-111.27C1540.78,956.55,1555.46,918.69,1567.78,917.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1638.26,963.79l15.39-38.85s37.48,25.47,43.65,57.75a88.87,88.87,0,0,0-32.58,8.74C1661.94,976.18,1638.26,963.79,1638.26,963.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1602.25,1000.36s42.08,23.78,56.28,3.47c3-4.22,6.87-9.74,6.15-13.74,12.61-6.37,22.28-6.87,29.36-7.4a44.58,44.58,0,0,1-4.84,30.56c-24.88,45.49-92.52-2.52-92.52-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1607.31,1030.44l-23-80.2a2.35,2.35,0,0,0-2-1.69c-4.16-.48-16.22-1.84-30.14-3-16.77-1.42-36.24-2.57-47.88-1.59a2.35,2.35,0,0,0-1.92,3.38c6.62,13.38,33.84,67.84,47.47,85.68a2.35,2.35,0,0,0,1.9.93l53.28-.5A2.35,2.35,0,0,0,1607.31,1030.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1549.84,938.57l-16.65-2.77a1.19,1.19,0,0,0-1.33,1.55l1.64,5a1.22,1.22,0,0,0,1,.81l16,2.14a1.2,1.2,0,0,0,1.33-1.46l-1-4.36A1.21,1.21,0,0,0,1549.84,938.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1562.31,952.67l-1.37-7.14a1.67,1.67,0,0,0-1.46-1.34l-33.63-3.41a1.65,1.65,0,0,0-1.77,2l2.13,8.9a1.67,1.67,0,0,0,1.53,1.27l32.86,1.65A1.65,1.65,0,0,0,1562.31,952.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1601.76,1011.06s3.2-13.15,1.91-17.82-3.8-10.67-12.13-9.33a122,122,0,0,0-18.17,4.84s.5,6.08,6.84,4.12l-3.93,3s.56,4.87,5.91,2.27l-3.65,4s2.29,4,6.23,1.43S1590.59,1012.65,1601.76,1011.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1516.36,991.49s-9.69-9.44-11.08-14.08-2.46-11.06,5.31-14.35a121.91,121.91,0,0,1,18-5.55s2.81,5.42-3.6,7.12l4.94.49s2.11,4.42-3.8,5.06l5.23,1.47s.18,4.61-4.52,4.53S1526.66,986.9,1516.36,991.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1605,884.86l12.77,36.92a1.34,1.34,0,0,1-.61,1.61c-3.48,1.92-16,7.48-31.13-2.1a6.25,6.25,0,0,1-2.89-4.47l-4.13-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1577.23,850.67s-14,26.39-12.23,37.05,19.18,9.9,34.35,1.24l10.6-28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1598.68,875a1.09,1.09,0,0,1-.48-1.59,28.41,28.41,0,0,0,3.91-8.28s2.52-1.61-6.42-3.75-22.26-5.46-25.06-13.07c-2.73-7.41,4.44-26.06,15.89-11.2a1.08,1.08,0,0,0,1.72,0c1.88-2.44,6.81-7.51,13.66-4.44,6.41,2.88,7.13,7.57,7,9.94a1.08,1.08,0,0,0,1.28,1.11c3.24-.62,11-1.15,14.64,6.83,3,6.57,1.05,10.29-.72,12.11a1.08,1.08,0,0,0,.47,1.8c2.13.65,4.88,2.46,4.6,7.45-.38,6.89-8.09,6.29-10.29,6a1.08,1.08,0,0,0-1,.34c-1.89,2.09-10.37,10.93-19.55,12a1.1,1.1,0,0,1-1.15-1.45l4-11.55a1.08,1.08,0,0,0-.59-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1597.08,876.6s10-6.85,10.71-1.08-9,8.36-13.8,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.87,1246.88c-92.27-4.44-173-120.8-147.39-180.84,17.33-40.58,72-29.13,100.14-75.54,35.93-59.27-32.09-112.76-30.14-220.76C106.13,677.83,158,569.3,213,563.46c57.57-6.13,134.13,98.6,120.65,187.14-8.76,57.58-51,78.33-42.31,124.64,10.14,53.75,72.31,53.61,93,101.07C421.48,1061.56,303.94,1252.75,181.87,1246.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.07,1261.89a3.52,3.52,0,0,1-1.48.29,3.06,3.06,0,0,1-3.1-3.26c17.81-238.11-49.28-476.75-50-479.14a3.34,3.34,0,0,1,2.37-4,3.22,3.22,0,0,1,4.1,2.06c.68,2.4,68.06,242.06,50.17,481.24A3.42,3.42,0,0,1,237.07,1261.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M222.15,992.58C215,927.83,241.31,854.89,255.72,787.3c7.61-35.73,11.9-71.33,7.57-107.81-4.3-36.27-19.67-75.93-2.62-111.21,34.36-71.09,107.84-35.17,148.5,21,47.19,65.2,56.64,169,72.33,249.29,9.47,48.4,24.64,98.26,28.69,147.35,6.7,81.33-13.85,136.78-54.08,173.17a117.24,117.24,0,0,1-139.85,13.07C276.14,1147.67,233.75,1097,222.15,992.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.13,1297.19a1.82,1.82,0,0,0,1-1.26c7-33.5,21.55-125.45,26.24-233.76,3.43-79.5,1.33-156.35-6.26-228.43-9.48-90.12-27.62-173-53.9-246.28a1.8,1.8,0,0,0-3.38,1.21c26.18,73,44.25,155.59,53.71,245.41,7.57,71.88,9.67,148.55,6.24,227.87-4.67,108.08-19.16,199.83-26.17,233.24a1.79,1.79,0,0,0,1.39,2.12A1.74,1.74,0,0,0,382.13,1297.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M526.17,1274.67c-41.95,2.73-88.21-48.77-98.54-99.68-10.64-52.4,23.88-69.16,32.89-138.7,10.23-79-29.26-96.37-42.26-206.41-2.94-24.83-19.91-168.52,27.52-188.71,43.86-18.67,148.84,65.64,157.08,156.77,5.87,65-41.77,85.59-34.7,161.3,6.2,66.43,44.93,72.53,51.54,136.71C627.74,1174.08,581.26,1271.08,526.17,1274.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M520.66,1293.4c22.34-83.6,18.32-217.71,11-315.49-7.91-105.87-21.27-193.14-21.4-194l-3.54.55c.14.87,13.48,88,21.38,193.75,7.28,97.5,11.31,231.16-10.91,314.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M529,1095.49c-6.68-44,9.31-94.49,17.29-141,4.21-24.59,6.17-49,2.22-73.78S533,829.42,543.7,804.88c21.5-49.45,72.63-27,101.91,10.28,34,43.2,43.28,113.79,56.18,168.14,7.79,32.77,19.51,66.38,23.61,99.77,6.8,55.32-5.7,93.72-32.17,119.66a80.06,80.06,0,0,1-95.08,12.74C570.1,1199.85,539.79,1166.45,529,1095.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M646,1300.91a3,3,0,0,0,3-2.51c.11-.67,11.24-67.85,11.53-160.53.27-85.58-8.91-211.09-54.16-323a3,3,0,1,0-5.59,2.26c44.87,111,54,235.58,53.73,320.59-.29,92.21-11.35,159-11.46,159.67a3,3,0,0,0,2.47,3.47A2.92,2.92,0,0,0,646,1300.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 550.67,
    cy: 133.45,
    r: 58.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M609,130.32H492.26s-4.65,32.43,47.48,121.23a12.76,12.76,0,0,0,21.85,0C613.72,162.78,609,130.32,609,130.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M550.64,259.64V260h0a14.48,14.48,0,0,1-12.38-7.15c-30.48-51.91-41.64-84.73-45.64-103.1a59.25,59.25,0,0,1-2-12.61,29.69,29.69,0,0,1-.05-6.37l.16-.93a60.1,60.1,0,0,1,119.94.59,25.73,25.73,0,0,1,.1,3.22v.22a60.17,60.17,0,0,1-2.41,16.89C604.23,169.08,593,201.58,563,252.61A14.15,14.15,0,0,1,550.64,259.64ZM493.85,133c0,.88,0,2.13.17,4h0a55.14,55.14,0,0,0,1.9,11.9l0,.07c3.94,18.11,15,50.53,45.26,102.09a11,11,0,0,0,9.45,5.38v0a11.52,11.52,0,0,0,9.48-5.43c29.76-50.71,40.87-82.94,45-101l0-.1a56.49,56.49,0,0,0,1.95-16l-.34-.24v0a20.94,20.94,0,0,1,.26-2.85l.16-.1A56.49,56.49,0,0,0,550.59,77.4c-30,0-54.87,23.71-56.58,53.83L494,133Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 550.86,
    cy: 133.27,
    r: 33.73,
    transform: "translate(-9.07 220.95) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M550.86,168.88a35.62,35.62,0,1,1,35.61-35.61A35.65,35.65,0,0,1,550.86,168.88Zm0-67.46a31.85,31.85,0,1,0,31.84,31.85A31.89,31.89,0,0,0,550.86,101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M518.86,98.15a.57.57,0,0,1-.37-1,52.4,52.4,0,0,1,34.09-12.61.56.56,0,0,1,.57.56.57.57,0,0,1-.57.57A51.22,51.22,0,0,0,519.23,98,.59.59,0,0,1,518.86,98.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.8,137.45a.57.57,0,0,1-.56-.57,52.14,52.14,0,0,1,7.83-27.55.57.57,0,0,1,.78-.19.58.58,0,0,1,.18.78,51.13,51.13,0,0,0-7.66,27A.58.58,0,0,1,500.8,137.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1035.29,
    cy: 59.45,
    r: 58.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1093.6,56.32H976.88s-4.65,32.42,47.48,121.22a12.76,12.76,0,0,0,21.86.05C1098.35,88.77,1093.6,56.32,1093.6,56.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1035.27,185.63V186h0a14.5,14.5,0,0,1-12.39-7.15c-30.47-51.91-41.64-84.73-45.64-103.1a58.41,58.41,0,0,1-2-12.61,29.77,29.77,0,0,1,0-6.37l.15-.93a60.11,60.11,0,0,1,119.95.59,26.74,26.74,0,0,1,.09,3.22v.22a60.48,60.48,0,0,1-2.4,16.89c-4.14,18.35-15.38,50.85-45.33,101.88A14.16,14.16,0,0,1,1035.27,185.63ZM978.47,58.94c0,.88,0,2.13.17,4h0a55.16,55.16,0,0,0,1.91,11.9l0,.07c3.94,18.12,15,50.53,45.26,102.09a11,11,0,0,0,9.45,5.38v0a11.5,11.5,0,0,0,9.47-5.43c29.77-50.71,40.88-82.93,45-101l0-.1a56.49,56.49,0,0,0,2-16l-.34-.24v0a22.69,22.69,0,0,1,.26-2.84l.16-.1a56.49,56.49,0,0,0-56.54-53.24c-30,0-54.87,23.71-56.58,53.83l0,1.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1035.48,
    cy: 59.26,
    r: 33.73,
    transform: "translate(261.38 749.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1035.48,94.87a35.61,35.61,0,1,1,35.62-35.61A35.65,35.65,0,0,1,1035.48,94.87Zm0-67.46a31.85,31.85,0,1,0,31.85,31.85A31.88,31.88,0,0,0,1035.48,27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1003.49,24.14a.57.57,0,0,1-.43-.2.55.55,0,0,1,.06-.79,52.32,52.32,0,0,1,34.09-12.62.57.57,0,0,1,0,1.13A51.21,51.21,0,0,0,1003.85,24,.53.53,0,0,1,1003.49,24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M985.43,63.44a.56.56,0,0,1-.57-.56,52.26,52.26,0,0,1,7.83-27.56.56.56,0,0,1,.78-.18.56.56,0,0,1,.18.78,51.1,51.1,0,0,0-7.66,27A.56.56,0,0,1,985.43,63.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 837.5,
    cy: 246.7,
    r: 58.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.81,243.57H779.09S774.43,276,826.57,364.8a12.76,12.76,0,0,0,21.85,0C900.55,276,895.81,243.57,895.81,243.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M837.47,372.89v.33h0a14.48,14.48,0,0,1-12.38-7.15c-30.48-51.91-41.64-84.74-45.64-103.1a59.25,59.25,0,0,1-2-12.61,29.69,29.69,0,0,1-.05-6.37l.16-.94a60.11,60.11,0,0,1,119.94.6,25.62,25.62,0,0,1,.1,3.22v.22A60.17,60.17,0,0,1,895.2,264c-4.14,18.35-15.37,50.85-45.33,101.88A14.15,14.15,0,0,1,837.47,372.89ZM780.68,246.2c0,.88,0,2.13.17,4h0a55.13,55.13,0,0,0,1.9,11.91l0,.07c3.94,18.11,15,50.53,45.26,102.09a11,11,0,0,0,9.45,5.38v0a11.53,11.53,0,0,0,9.48-5.42c29.76-50.71,40.87-82.94,44.95-101l0-.11a56.4,56.4,0,0,0,2-16l-.34-.23v0a20.94,20.94,0,0,1,.26-2.85l.16-.1a56.5,56.5,0,0,0-56.55-53.24c-30,0-54.86,23.72-56.57,53.83l-.05,1.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 837.69,
    cy: 246.51,
    r: 33.73,
    transform: "translate(71.04 664.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M837.69,282.13a35.62,35.62,0,1,1,35.61-35.62A35.66,35.66,0,0,1,837.69,282.13Zm0-67.46a31.85,31.85,0,1,0,31.84,31.84A31.89,31.89,0,0,0,837.69,214.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M805.69,211.4a.57.57,0,0,1-.43-.2.58.58,0,0,1,.06-.8,52.41,52.41,0,0,1,34.09-12.62.58.58,0,0,1,.57.57.57.57,0,0,1-.57.56,51.23,51.23,0,0,0-33.35,12.35A.59.59,0,0,1,805.69,211.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M787.63,250.7a.57.57,0,0,1-.56-.57,52.11,52.11,0,0,1,7.83-27.55.56.56,0,0,1,.77-.19.57.57,0,0,1,.19.78,51,51,0,0,0-7.66,27A.58.58,0,0,1,787.63,250.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 450.19,
    cy: 397.01,
    r: 58.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M508.5,393.88H391.78s-4.65,32.42,47.48,121.22a12.76,12.76,0,0,0,21.86,0C513.24,426.33,508.5,393.88,508.5,393.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450.17,523.19v.33h0a14.48,14.48,0,0,1-12.38-7.15c-30.47-51.91-41.64-84.73-45.64-103.1a58.41,58.41,0,0,1-2-12.61,29.47,29.47,0,0,1-.06-6.37l.16-.93A60.1,60.1,0,0,1,510.2,394a25.84,25.84,0,0,1,.1,3.22v.22a60.12,60.12,0,0,1-2.41,16.89c-4.13,18.35-15.37,50.85-45.32,101.88A14.17,14.17,0,0,1,450.17,523.19ZM393.37,396.5c0,.88,0,2.13.17,4h0a55.76,55.76,0,0,0,1.9,11.9l0,.07c3.94,18.12,15,50.53,45.26,102.09a11,11,0,0,0,9.45,5.38v0a11.5,11.5,0,0,0,9.47-5.43c29.76-50.71,40.87-82.93,44.95-101l0-.1a56.49,56.49,0,0,0,1.95-16l-.34-.24v0a22.69,22.69,0,0,1,.26-2.84l.16-.1A56.49,56.49,0,0,0,450.11,341c-30,0-54.87,23.71-56.58,53.83l0,1.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 450.38,
    cy: 396.82,
    r: 33.73,
    transform: "translate(-59.92 712.88) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450.38,432.43A35.62,35.62,0,1,1,486,396.82,35.64,35.64,0,0,1,450.38,432.43Zm0-67.46a31.85,31.85,0,1,0,31.85,31.85A31.88,31.88,0,0,0,450.38,365Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.38,361.7a.56.56,0,0,1-.42-.2.55.55,0,0,1,.06-.79,52.31,52.31,0,0,1,34.08-12.62.56.56,0,0,1,.57.56.57.57,0,0,1-.57.57,51.22,51.22,0,0,0-33.35,12.34A.5.5,0,0,1,418.38,361.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.32,401a.56.56,0,0,1-.56-.57,52.25,52.25,0,0,1,7.83-27.55.56.56,0,0,1,.78-.18.57.57,0,0,1,.18.78,51.1,51.1,0,0,0-7.66,26.95A.56.56,0,0,1,400.32,401Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M615.3,940.94s-16.38,5.45-27,28.85c-2.9,6.4-18.65,7.53-20.27,20.65a15.06,15.06,0,0,1-12.6,13.24c-16.81,2.57-42.71,11.3-46.85,40.48-3.17,22.27,8.19,30.72,20.1,33.64a16.88,16.88,0,0,1,12.8,19.5c-1.7,8.47.84,18.27,15.52,26,32.9,17.36,65.76-41.13,65.76-41.13l6.73-102.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M721,937.77s-41,64.82-89.72,77.34c0,0,9.5,27.05,16.83,30.15,0,0,60-50,75.36-98.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M525,1352.4l-1.33,10.92a4.51,4.51,0,0,1-4,4,69.34,69.34,0,0,1-14.62.22,3.85,3.85,0,0,1-3.24-5c1.34-4.21,3.79-10.54,7.32-14.26h12.12A3.73,3.73,0,0,1,525,1352.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M619.84,1224.48l2,12s-6.84,69.35-8.06,97.09A21.71,21.71,0,0,0,617,1346l11.9,19.33-30.26-17.86-.6-3.69,5-6.81-6.49-77.69a23.88,23.88,0,0,1,2.71-13.19l6.26-11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M630.93,1368.09h-9.65a5.84,5.84,0,0,1-4.62-2.26c-3-3.91-9.24-11.54-12.22-11.74-4-.27-3.51,14-3.51,14h-2.25l-2.85-17.73a10.52,10.52,0,0,1,5.51-11h0s.92,6.79,5.9,9.79,20.25,13.75,20.25,13.75a14,14,0,0,1,3.92.11A2.55,2.55,0,0,1,630.93,1368.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M578.4,1230.19s-40.11,76.09-46.49,93.46a167,167,0,0,0-8.7,33.24c-.13,2.14-2.8,4.2-10.15,4.2-3.79,0-5.65-1.52-6.56-3a4.28,4.28,0,0,1-.16-4.16c2.32-4.69,9.68-19.7,12.41-26.5,3.25-8.13,10.26-45,14.1-57.76s8.18-26.69,24.91-39.49C557.76,1230.19,569.24,1219,578.4,1230.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M603.74,1105.52c10.34-43.84-15.87-68.64-15.87-68.64,16.54-15.88,46.67-23.1,46.67-23.1s28.76,21,25.35,37.47c-2,9.65-20.21,57.77-20.21,57.77S622.83,1117,603.74,1105.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M580.8,1127.23c4.21-12.69,22.94-21.71,22.94-21.71,19.09,11.47,35.94,3.5,35.94,3.5s3.77,14.44,1.17,27.85-19,99.64-19,99.64c-25.76,5.22-65.4-5.26-65.4-5.26C572.9,1202.11,576.58,1139.91,580.8,1127.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M615.75,984.8l-8.42,37.79c-.8,3.33,2.23,2.78,5.6,2.15,5.51-1,12.61-3.18,15-7.47a3.72,3.72,0,0,0,.43-1.42l3.62-26.2a4.71,4.71,0,0,0-2.76-4.95l-7-3.09A4.7,4.7,0,0,0,615.75,984.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M631.86,950.36s8.95,6.06,12.8,21.5-2.4,21-8.81,20.64-15.71-2.33-23.76-13.4S620.12,943,631.86,950.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M620.21,972.87s-3.28-22.12,15.08-18.74L639,958s9-10.12-1-17.78-23.76-5.69-31.39,8.24-10.41,23.73-4,32.38,11.22,1.24,11.22,1.24-2.94-7.5-.5-10.71,5.58,1.87,5.58,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M720.75,951.11c.12,1.34-4.85,2.26-6.43-3.44.43-2.47,1.21-13.31,3.1-15,10.11-9,28.13-19.06,28.13-19.06a3.68,3.68,0,0,1-.62,5.1l-9,6.07c.94,3.11,2.31,5.86,2.46,9.41a10.5,10.5,0,0,1-2.66,7.36c-1.79,2-4.2,4.68-6.37,6.69A10.38,10.38,0,0,1,720.75,951.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M725.58,946.67l-1.26-.52c.18-.44,4.49-10.92,6.57-13.1a3.17,3.17,0,0,0,1.16-2.15,1.59,1.59,0,0,0-.51-1l-7.33,3.92-3.23,5-1.15-.74,3.42-5.35,8.47-4.53.36.29a3.16,3.16,0,0,1,1.33,2.27,4.37,4.37,0,0,1-1.53,3.19C730.3,935.65,726.8,943.7,725.58,946.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M587.87,1036.88s-46.57,95.62-63.43,104c0,0-17.13,1.79-27.61,5a2.74,2.74,0,0,0,.11,5.27c7.3,2,19.39,3.65,30.47-2.36,0,0-5.95,8.92-2.48,12.4,0,0,7.94-9.43,10.91-12.4,2.62-2.62,50.32-54.62,70.36-86,1.62-2.54.5-10.07-.62-12.85C603,1043.48,597.24,1033.23,587.87,1036.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M623.14,942.16a34,34,0,0,0-10.66,6.27,45.37,45.37,0,0,0-13.88,20.2,43.92,43.92,0,0,0-1.56,6,58,58,0,0,1-1.35,6.18,13.6,13.6,0,0,1-3.16,5.66,20.31,20.31,0,0,1-5.24,3.75c-1.86,1-3.76,1.87-5.55,2.87a22.74,22.74,0,0,0-11,14c-.56,2-1,4-1.74,6.08a12.41,12.41,0,0,1-3.65,5.44,15.68,15.68,0,0,1-5.83,2.91,57.43,57.43,0,0,1-6.2,1.29,51.23,51.23,0,0,0-11.89,3.33c-7.54,3.18-14.45,8.52-18.15,15.87a20.49,20.49,0,0,0-2.18,11.82,17.67,17.67,0,0,0,5.33,10.7,13.29,13.29,0,0,0,5.22,3,13.88,13.88,0,0,0,6.05.28,12,12,0,0,0,9.39-7.08l.32.12c-1.48,4.05-5.43,6.81-9.6,7.56a14.68,14.68,0,0,1-6.36-.17,14.18,14.18,0,0,1-5.6-3.07,18.53,18.53,0,0,1-5.77-11.21,21.61,21.61,0,0,1,2.14-12.48,30.94,30.94,0,0,1,7.87-10,42.24,42.24,0,0,1,10.81-6.61,52.58,52.58,0,0,1,12.18-3.47,56.93,56.93,0,0,0,6-1.28,14.3,14.3,0,0,0,5.3-2.65,11.25,11.25,0,0,0,3.23-4.84c.71-1.89,1.15-3.93,1.74-6a24,24,0,0,1,11.66-14.76c1.86-1,3.77-1.9,5.59-2.87a19.08,19.08,0,0,0,4.93-3.48,12.56,12.56,0,0,0,2.94-5.14,57.76,57.76,0,0,0,1.39-6A44.83,44.83,0,0,1,612.09,948,34.45,34.45,0,0,1,623,941.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M600.94,970.78a61.05,61.05,0,0,1-.78,8.07,22.45,22.45,0,0,1-2.72,7.74,15.55,15.55,0,0,1-2.63,3.26,27,27,0,0,1-3.25,2.55,64.37,64.37,0,0,0-6.45,4.72c-4,3.42-7.32,7.69-8.37,12.81-1.2,5.06-.87,10.67-3.12,16a17.29,17.29,0,0,1-5.28,6.62,27,27,0,0,1-7.34,4c-5.22,1.89-10.63,2.55-15.81,3.73s-10.27,3.11-13.9,6.91c-1.76,1.87-3.32,4.19-3.35,6.77s1.18,5.09,2.36,7.48l-.3.16c-1.33-2.31-2.74-4.78-2.84-7.64a8.82,8.82,0,0,1,1-4.1,15.5,15.5,0,0,1,2.33-3.45c3.77-4.19,9.13-6.36,14.37-7.71s10.64-2,15.55-3.88,9.44-5,11.43-9.65,1.87-10.21,3.15-15.6a21.56,21.56,0,0,1,3.43-7.63,29.79,29.79,0,0,1,5.71-6c4.15-3.61,9.62-5.42,12.39-9.9a21.86,21.86,0,0,0,2.93-7.29,74.86,74.86,0,0,0,1.2-7.94Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectmanagement2);
export default __webpack_public_path__ + "static/media/projectmanagement_2.4862f3953d413b17e15b48f47f7371f8.svg";
export { ForwardRef as ReactComponent };